module.exports = __webpack_public_path__ + "static/media/banner_lcdlm2_small@2x.1a5fa40f.jpg";